import React, {Fragment} from 'react';
import {Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography} from "@material-ui/core";
import setDate from '../../utils/setDate';
import {useQuery} from "@apollo/react-hooks";
import {gql} from "apollo-boost";
import useStyles from "../../styles/styles";

const BidsTableShortForm = ({apiRequestId}) => {
    const classes = useStyles();

    const {loading, error, data} = useQuery(gql`
        query Bids($apiRequestId: UUID!) {
            bids(apiRequestId: $apiRequestId) {
                applicationId
                campaignDecisionId
                campaignId
                dateCreated
                expirationInSeconds
                expires
                entityId
                identityId
                leadId
                originalRequestId
                dateModified
                originalTimestamp
                pricePoint
                redeemedRequestId
                redeemedTimestamp
                status
                token
            }
        }
    `, {
        variables: {
            apiRequestId: apiRequestId,
        },
        context: {
            clientName: "kgraphql"
        }
    });

    const bids = data?.bids ?? []

    if (loading) {
        return (
            <>
            </>
        );
    }

    if (!bids.length || error) {
        return (
            <>
            </>
        );
    }

    return (
        bids && bids.length > 0 ? (
            <>
                <Typography variant="h4" component="h4" align="left">Bid Data</Typography>
                <Paper className={classes.paper}>
                    <Table className={classes.table} size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell variant="head">Bid Created</TableCell>
                                <TableCell variant="head">Campaign Id</TableCell>
                                <TableCell variant="head">Bid</TableCell>
                                <TableCell variant="head">Status</TableCell>
                                <TableCell variant="head">Expiration</TableCell>
                                <TableCell variant="head">Lead Id</TableCell>
                                <TableCell variant="head">Application Id</TableCell>
                                <TableCell variant="head">Loan / Redeem Request Id</TableCell>
                                <TableCell variant="head">Redeem Timestamp</TableCell>
                                <TableCell variant="head">Token</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.apiRequest.apiRequest.bids.map(bid => (
                                <TableRow key={bid.id}>
                                    <TableCell variant="body">{setDate(bid.originalTimestamp)}</TableCell>
                                    <TableCell variant="body">{bid.campaignId}</TableCell>
                                    <TableCell variant="body">${bid.pricePoint}</TableCell>
                                    <TableCell variant="body">{bid.status}</TableCell>
                                    <TableCell variant="body">{bid.expires}</TableCell>
                                    <TableCell variant="body">{bid.leadId}</TableCell>
                                    <TableCell variant="body">{bid.applicationId}</TableCell>
                                    <TableCell variant="body">
                                        {bid.redeemedRequestId && bid.loanRequestId ? (
                                                <Fragment>
                                                    <a
                                                        href="/#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            window.open(`/info/leads/${bid.loanRequestId}`)
                                                        }}
                                                    >
                                                        Original
                                                    </a>
                                                    <span style={{padding: "0 10px"}}>|</span>
                                                    <a
                                                        href="/#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            window.open(`/info/leads/${bid.redeemedRequestId}`)
                                                        }}>
                                                        Redeemed
                                                    </a>
                                                </Fragment>
                                            )
                                            : 'N/A'}
                                    </TableCell>
                                    <TableCell
                                        variant="body">{bid.redeemedTimestamp ? setDate(bid.redeemedTimestamp) : 'N/A'}</TableCell>
                                    <TableCell variant="body">{bid.token}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
            </>
        ) : null
    );
};

export default BidsTableShortForm
